import { EventContext } from "../types";

/**
 * Logs a styled tracking message to the console with the destination and event payload.
 *
 * @param data - The event payload or context to include in the log; if falsy, an empty string is logged
 * @param color - CSS background color used for the log label
 * @param destination - Destination name shown in the log label (prefixed by "DT - ")
 */
export function dataTrackingLog(data: EventContext, color: string, destination: string) {
  console.log(
    `%c[DT - ${destination}] EVENTO DISPARADO:%c `,
    `background: ${color}; color: white; font-weight: bold; padding: 2px 4px; border-radius: 3px;`,
    'color: #fff;',
    data || ''
  );
}